<template>
  <v-dialog v-model="dialog" width="340" persistent>
    <template v-slot:activator="{ on }">
      <v-text-field
        :label="label"
        v-on="on"
        outlined
        readonly
        :value="formatedDate"
        dense
        :disabled="disabled"
        :rules="rules"
      ></v-text-field>
    </template>
    <v-card>
      <v-card-title> Date Time Picker </v-card-title>
      <v-divider></v-divider>
      <div
        class="d-flex mb-4 pl-4 pr-4 mt-4 justify-space-between align-center"
      >
        <vue-timepicker
          v-model="start"
          input-width="140px"
          format="hh:mm A"
          placeholder="Time"
        ></vue-timepicker>
      </div>
      <v-divider></v-divider>
      <v-date-picker
        no-title
        v-model="date"
        full-width
      ></v-date-picker>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Close</v-btn>
        <v-btn text color="success" @click="submit()">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import VueTimepicker from "vue2-timepicker";
export default {
  props: {
    value: {},
    label: {
      default: "",
    },
    endAt: {},
    disabled: {},
    rules: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {
    VueTimepicker,
  },
  data() {
    return {
      date: "",
      start: "",
      end: "",
      dialog: false,
      activeTab: 0,
    };
  },
  computed: {
    formatedDate() {
      let { start } = this;
      if (!this.date) return "";
      let date = moment(this.date, "YYYY-MM-DD").format("MM/DD/YYYY");
      let msg = `${date}`;
      if (start) {
        msg = `${date} ${start}`;
      }
      return msg;
    },
  },
  watch: {
    value() {
      this.init();
    },
    dialog() {
      this.init();
    },
  },
  methods: {
    onStartSelected() {
      console.log("this");
      const vm = this;
      let { start, end } = vm;
      if (vm.isValidTime(start) && (!end || !vm.isValidTime(end))) {
        vm.end = moment(start, "hh:mm A").add(2, "hours").format("hh:mm A");
      }
    },
    isValidTime(time) {
      if (!time) return true;
      if (time.indexOf("hh") != -1) return true;
      if (time.indexOf("mm") != -1) return true;
      if (time.indexOf("AM") == -1 && time.indexOf("PM") == -1) return true;
      return false;
    },
    submit() {
      const vm = this;
      let { start, date } = vm;
      if (vm.isValidTime(start)) return vm.$alert.show("Select valid time");
      if (!date) return vm.$alert.show("Select date");
      if (!this.date) return this.$emit("input", "");
      let datetime = moment(date + " " + start, "YYYY-MM-DD hh:mm A").format(
        "YYYY-MM-DDTHH:mm"
      );
      vm.$emit("input", datetime);
      vm.dialog = false;
    },
    init() {
      if (this.value) {
        let split = this.value.split("T");
        this.date = split[0];
        if (split[1]) {
          this.start = moment(split[1], "HH:mm").format("hh:mm A");
        }
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style></style>
